// axios-config.js
import axios from 'axios';

const apiEndpoint = process.env.REACT_APP_SERVER || '/api/';

const axiosInstance = axios.create({
  baseURL: apiEndpoint,
  withCredentials: true
});

// Intercept 401 responses to force logout across all tabs
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (
      error.response &&
      error.response.status === 401 &&
      !error.config.url.includes('login/login') &&
      !error.config.url.includes('login/logout')
    ) {
      // Clear all local auth state
      localStorage.clear();
      // Redirect to login page
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
